import { createGlobalStyle } from "styled-components";
const ModalStyle = createGlobalStyle`
    a.download-btn-service {
        color : #3c3c3c;
    }
    
    p.closeCamera button {
      position: absolute;
      background-color: transparent;
      top: 5px;
      right: 5px;
      padding: 5px 13px;
      border-radius: 50%;
      color: #BDFF00;
      font-size: 20px;
      border: 1px solid #BDFF00;
    }
`;

export default ModalStyle;
